import { jsx as _jsx } from "react/jsx-runtime";
import { Popover } from "antd";
import { useMemo, useState } from "react";
import { ETranslationFlag } from "@devowl-wp/api";
import { DEFAULT_LANGUAGE } from "@devowl-wp/api-real-cookie-banner";
import { TranslationFlagsSelector } from "./translation-flag-selector.js";
import { useTranslation } from "../../../../../../../others/i18n.js";
import { getLanguageIcon } from "../../../../../../../util/translation.js";
/**
 * Displays an icon for a specified language. When a translation flag path is provided, it also includes a popover
 * that allows editing of translation flags via a selector. If no flag path is provided, the icon is simply displayed with a tooltip.
 *
 * @param props - The properties for configuring the language icon.
 * @param props.lang - The language associated with the icon.
 * @param props.flexPathConfig - Form name path configurations.
 */ function LanguageIcon({ lang, flexPathConfig }) {
    const icon = useMemo(()=>getLanguageIcon(lang), [
        lang
    ]);
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const content = /*#__PURE__*/ _jsx(TranslationFlagsSelector, {
        flexPathConfig: flexPathConfig,
        visible: open,
        lang: lang,
        hiddenFlags: lang === DEFAULT_LANGUAGE ? [
            ETranslationFlag.MachineTranslated
        ] : []
    });
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx(Popover, {
            open: open,
            title: t("Edit flags for this translation"),
            content: content,
            placement: "left",
            onOpenChange: (visible)=>setOpen(visible),
            forceRender: true,
            children: icon
        })
    });
}
export { LanguageIcon };
